<template>
    <div class="flex text1 step-box mb30">
      <div
        class="flex-1 flex flex-col flex-center align-items-center"
        @click="stepJump(1)"
      >
        <img
          v-if="showIndex === 1"
          class="img-box"
          src="../../assets/images/img34_active.png"
          alt=""
        />
        <img
          v-else
          class="img-box"
          src="../../assets/images/img34.png"
          alt=""
        />
        <div>1.填写报名信息</div>
      </div>
      <div
        class="flex-1 flex flex-col flex-center align-items-center main-box-line"
         @click="stepJump(2)"
      >
        <div class="line left50"></div>
        <div class="line right50"></div>
        <img
          v-if="showIndex === 2"
          class="img-box"
          src="../../assets/images/img32_active.png"
          alt=""
        />
        <img
          v-else
          class="img-box"
          src="../../assets/images/img32.png"
          alt=""
        />
        <div>2.上传参赛作品文档材料</div>
      </div>
      <div
        class="flex-1 flex flex-col flex-center align-items-center"
         @click="stepJump(3)"
      >
        <img
          v-if="showIndex === 3"
          class="img-box"
          src="../../assets/images/img33_active.png"
          alt=""
        />
        <img
          v-else
          class="img-box"
          src="../../assets/images/img33.png"
          alt=""
        />
        <div>3.上传申报书及佐证材料</div>
      </div>
    </div>
</template>

<script>
export default {
     name:'',
    components: {

    },
    props: {
        showIndex:Number
    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      stepJump(type){
        this.$emit('stepJump',type)
      }
    },
};
</script>

<style scoped lang="scss">
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb30 {
  margin-bottom: 20px;
}
.step-box {
  padding-bottom: 10px;
}
.img-box {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 16px;
}

.line {
  position: absolute;
  top: 28%;
  width: 240px;
  height: 1px;
  background: #e3e3e3;
}
.left50 {
  left: 68%;
}
.right50 {
  right: 68%;
}
.main-box-line {
  position: relative;
}
</style>
